//------------------------
// get adj collection key
//------------------------
export default function getAdjCollectionKey(category = '') {
  if (category === 'characteristic-skill') {
    return 'characteristic_skill_adjs'
  }

  return `${category}_adjs`
}
